import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getIcon } from "utils/iconsConfig";
import "./SecondSidebar.css";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";

const SecondSidebar = ({ isOpen, setIsOpen }) => {
  const [height, setHeight] = useState(window.innerHeight);
  const navigate = useNavigate();
  const location = useLocation();

  const { clientId } = useParams();
  const permissions = usePermissions();

  const hasAccessToPurchase = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Purchases"), "view");
  const hasAccessToCatalog = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Catalog"), "view");
  const hasAccessToDues_LedgerView = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Dues & Ledger"), "view");
  const hasAccessToQuotes_OrdersView = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes & Orders"), "view");
  const hasAccessToWip = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "WIP"), "view");
  const hasAccessToNpdOrders = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "NPD Orders"), "view"); 
  const hasAccessToService_RequestView =isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Service Request"), "view"); 
  const hasAccessToService_RequestManagement =isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Service Request"), "management");
  const hasAccessToRequest_Visit = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Vision Web", permissions), "Request Visit"), "view"); 

  // const hasAccessToSeeCatalog = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Catalog"), "view");
  // const hasAccessToSeeDues_Ledger = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Dues & Ledger"), "view");
  // const hasAccessToSeeQuotes_Orders = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Quotes & Orders"), "view");
  // const hasAccessToSeeWip = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "WIP"), "view");
  // const hasAccessToSeeNpdOrders = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "NPD Orders"), "view");
  // const hasAccessToSeeService_Request = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Service Request"), "view");
  // const hasAccessToSeeRequest_Visit = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Request Visit"), "view");

  // const hasAccessToSeePurchase = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Purchases"), "view");
  // const hasAccessToSeeCatalog = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Catalog"), "view");
  // const hasAccessToSeeDues_Ledger = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Dues & Ledger"), "view");
  // const hasAccessToSeeQuotes_Orders = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Quotes & Orders"), "view");
  // const hasAccessToSeeWip = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "WIP"), "view");
  // const hasAccessToSeeNpdOrders = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "NPD Orders"), "view");
  // const hasAccessToSeeService_Request = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Service Request"), "view");
  // const hasAccessToSeeRequest_Visit = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Clients", permissions), "Request Visit"), "view");

  useEffect(() => {
    const updateHeight = () => setHeight(window.innerHeight);
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const getActiveItem = () => {
    const path = location.pathname;
    if (path === `/client-flow/${clientId}` || path.includes("client-flow/clients-purchase")) return "Purchases";
    if (path.includes("clients-catalog")) return "Catalog";
    if (path.includes("dues-ledger")) return "Dues & Ledger";
    if (path.includes("quotes-orders")) return "Quotes & Orders";
    if (path.includes("wip")) return "WIP";
    if (path.includes("npd-orders")) return "NPD Orders";
    if (path.includes("service-request")) return "Service Request";
    if (path.includes("request-visit")) return "Request Visit";
    return "Purchases";
  };

  const [active, setActive] = useState(getActiveItem());

  useEffect(() => {
    setActive(getActiveItem());
  }, [location.pathname]);

  const menuItems = [
    { name: "Purchases", path: `/client-flow/${clientId}/clients-purchases`, access: hasAccessToPurchase },
    { name: "Catalog", path: `/client-flow/${clientId}/clients-catalog`, access: hasAccessToCatalog },
    { name: "Dues & Ledger", path: `/client-flow/${clientId}/dues-ledger`, access: hasAccessToDues_LedgerView },
    { name: "Quotes & Orders", path: `/client-flow/${clientId}/quotes-orders`, access: hasAccessToQuotes_OrdersView },
    { name: "WIP", path: `/client-flow/${clientId}/wip`, access: hasAccessToWip },
    // { name: "NPD Orders", path: `/client-flow/${clientId}/npd-orders`, access: hasAccessToSeeNpdOrders },
    // { name: "Service Request", path: `/client-flow/${clientId}/service-request`, access: hasAccessToService_RequestView },
    // { name: "Request Visit", path: `/client-flow/${clientId}/request-visit`, access: hasAccessToSeeRequest_Visit },
  ];

  const handleMenuItemClick = (item) => {
    setActive(item?.name);
    let state = {
      breadCrumbName: [item?.name],
    };
    navigate(item?.path, { state });
  };

  return (
    <div style={{ height: `${height - 72}px` }}>
      <div className={`second-sidebar ${isOpen ? "" : "closed"}`} style={{ width: isOpen ? "200px" : "60px", transition: "all 0.8s ease" }}>
        <div>
          {menuItems
            .filter((item) => item.access)
            .map((item) => (
              <div
                key={item.name}
                style={{
                  display: "flex",
                  // justifyContent:"center",
                  alignItems: "center",
                  height: "36px",
                  padding: isOpen ? "6px 16px" : "6px 12px",
                  gap: "8px",
                  backgroundColor: active === item.name ? "#50C8781F" : "transparent",
                  minWidth: "36px",
                  cursor: "pointer",
                  transition: "all ease 0.8s",
                  borderRadius: "5px",
                }}
                onClick={() => handleMenuItemClick(item)}
              >
                <div className="icon" style={{ display: "flex" }}>
                  {getIcon(item.name, active === item.name && "Active")}
                </div>
                <span
                  style={{
                    // height:"20px",
                    whiteSpace: "nowrap",
                    display: isOpen ? "block" : "none",
                    color: active === item.name ? "#50C878" : "#8B8B8B",
                    transition: "display ease 0.8s",
                    fontSize: "12px",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  {item.name}
                </span>
              </div>
            ))}
        </div>
      </div>

      <div
        style={{
          position: "absolute",
          height: "30px",
          width: isOpen ? "200px" : "60px",
          bottom: 0,
          display: "flex",
          justifyContent: "flex-end",
          backgroundColor: "#4444444D",
          transition: "all 0.8s ease",
          // borderTop: "1px solid #444444",
        }}
      >
        <div className="notes-options" style={{ background: "#50C87833" }}>
          <button className="toggle-btn" onClick={toggleSidebar}>
            <span className="toggle-icon">{isOpen ? getIcon("Double_Arrow", "back") : getIcon("Double_Arrow")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecondSidebar;
